module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/agata-szatecka-c9af7789e7fbdfe7fad7722ebfb393f6.png";